import React, {memo, useEffect, useState} from "react";

import "../index.scss";
import { DropDown, Typography } from "components/atoms";
import { AI_CHAT_SELECT_SUBJECT } from "utils/constants/GoogleTagGUIDs";

interface SubjectSelectorProps {
  subjects: string[];
  selectedSubject: string;
  onSubjectChange: (subject: string) => void;
}

export const SubjectSelector: React.FC<SubjectSelectorProps> = memo(({
  subjects,
  selectedSubject,
  onSubjectChange,
}) => {

  const [dropdownValue, setDropdownValue] = useState<
    null | string | { [key: number]: string }
  >(selectedSubject || null);


  useEffect(() => {
    if (dropdownValue !== null) {
      if (typeof dropdownValue === "string") {
        onSubjectChange(dropdownValue);
      } else if (typeof dropdownValue === "object") {
        const value = Object.values(dropdownValue)[0];
        if (typeof value === "string") {
          onSubjectChange(value);
        }
      }
    }
  }, [dropdownValue, onSubjectChange]);

 
  useEffect(() => {
    if (selectedSubject && selectedSubject !== dropdownValue) {
      setDropdownValue(selectedSubject);
    }
  }, [selectedSubject]);

  return (
    <div className="subject-selector">
      <div className="subject-selector-label">
        <Typography
          label="To get started, select a subject:"
          variant="h7Book"
          styles="subject-label"
        />
      </div>
      <div className="subject-dropdown-container">
        <DropDown
          data={subjects}
          styles="subject-dropdown"
          setDropDownSelection={setDropdownValue}
          defaultSelected={dropdownValue}
          placeholder=""
          dataTrackingId={AI_CHAT_SELECT_SUBJECT}
        />
      </div>
    </div>
  );
});
